import * as elog from '@reverbdotcom/commons/dist/elog';
import * as Sentry from '@sentry/browser';
import { parseMeta } from './parse_meta';
import { initMParticleSDK } from '@reverbdotcom/commons/dist/elog/mparticle_tracker';

const ELOG_CONFIG_KEY = 'elog-config';
const CURRENT_USER_KEY = 'current-user';

window.Sentry = Sentry;

function initializeMParticle() {
  if (process.env.IS_SELENIUM === 'true') return;

  const userConfig = parseMeta(CURRENT_USER_KEY);
  const appConfig = parseMeta('app-config-meta');

  if (userConfig && appConfig) {
    initMParticleSDK();
  }
}

function init() {
  const elogConfig = parseMeta(ELOG_CONFIG_KEY);

  if (elogConfig) {
    const config = {
      ...elogConfig.elog,
      sentryClient: Sentry,
    };

    elog.configure(config);
    elog.identify(config.userContext);
    elog.pageView();
    initializeMParticle();
  }
}

window.addEventListener('load', () => {
  if (process.env.NODE_ENV === 'test') {
    return;
  }

  init();
});

export default {
  init, // for testing only
};



// WEBPACK FOOTER //
// ./javascripts/components/elog_init.js